export default __webpack_public_path__ + "static/media/element_63.6af30cd9.webp";